import { Abbr } from "@site/src/components";

export default function FirstPersonSingular() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td>azъ </td>
          <td>mene/mę </td>
          <td>mene </td>
          <td>mьně/mi </td>
          <td>mьnojǫ </td>
          <td>mьně</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td>ja</td>
          <td>menjá </td>
          <td>menjá </td>
          <td>mne </td>
          <td>mnoj </td>
          <td>mne </td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td>ja</td>
          <td>mjané </td>
          <td>mjané </td>
          <td>mne </td>
          <td>mnoj/mnoju </td>
          <td>mne </td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td>ja</td>
          <td>mené </td>
          <td>mené </td>
          <td>mení </td>
          <td>mnóju </td>
          <td>mení</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td>ja</td>
          <td>mene/mja/<br />nja/myja</td>
          <td>mene/mja/<br />nja/myja </td>
          <td>mi </td>
          <td>mnom </td>
          <td>mi/mni</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td>ja</td>
          <td>mnie/mię </td>
          <td>mnie </td>
          <td>mi </td>
          <td>mną </td>
          <td>mnie</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td>jô</td>
          <td>mnie/mie/mię </td>
          <td>mnie/mie </td>
          <td>mnie/mie</td>
          <td>mną </td>
          <td>mnie</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td>ja</td>
          <td>mě (mnjoj) </td>
          <td>mje (mnjo) </td>
          <td>mě (mnjo) </td>
          <td>mnu </td>
          <td>mnjo</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td>ja</td>
          <td>mje/mnje </td>
          <td>mje/mnje </td>
          <td>mi/mni </td>
          <td>mnu </td>
          <td>mni </td>
        </tr>
        <tr>
          <th>Czech</th>
          <td>já</td>
          <td>mne/mě </td>
          <td>mne/mě </td>
          <td>mně/mi </td>
          <td>mnou </td>
          <td>mně </td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td>ja</td>
          <td>mňa/ma </td>
          <td>mňa/ma </td>
          <td>mne/mi </td>
          <td>mnou </td>
          <td>mne </td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td>jaz </td>
          <td>mene/me </td>
          <td>mene/me </td>
          <td>meni/mi </td>
          <td>menój/mano </td>
          <td>meni</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td>jâ</td>
          <td>mène/me </td>
          <td>mène/me </td>
          <td>mèni/mi </td>
          <td>mnôm </td>
          <td>mèni</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td>jas </td>
          <td>mene/me </td>
          <td>— </td>
          <td>mene/mi </td>
          <td>— </td>
          <td>— </td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td>az</td>
          <td>méne/me </td>
          <td>— </td>
          <td>mi/méne </td>
          <td>— </td>
          <td>— </td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>ja</b>
          </td>
          <td>
            <b>mene/mę</b>
          </td>
          <td>
            <b>mene</b>
          </td>
          <td>
            <b>mně/mi</b>
          </td>
          <td>
            <b>mnojų</b>
          </td>
          <td>
            <b>mně</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}